import { render, staticRenderFns } from "./NewLoading.vue?vue&type=template&id=551e2624&"
import script from "./NewLoading.vue?vue&type=script&lang=js&"
export * from "./NewLoading.vue?vue&type=script&lang=js&"
import style0 from "./NewLoading.vue?vue&type=style&index=0&id=551e2624&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports